import {
  IMPORT_SUMMARY,
  IMPORTED_LEADS,
  LOADING,
  SELECTED_RECORDS,
} from "../actionType/importType";

const initialState = {
  loading: false,
  previewLeads: [],
  summary: [],
  selectedRecords: [],
};

const importReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case IMPORTED_LEADS:
      return { ...state, previewLeads: payload };
    case IMPORT_SUMMARY:
      return { ...state, summary: payload };
    case SELECTED_RECORDS:
      return { ...state, selectedRecords: payload };
    case LOADING:
      return { ...state, loading: payload };
    default:
      return state;
  }
};

export default importReducer;
